import { render, staticRenderFns } from "./UserNameDialog.vue?vue&type=template&id=b6a47328&scoped=true&"
import script from "./UserNameDialog.vue?vue&type=script&lang=js&"
export * from "./UserNameDialog.vue?vue&type=script&lang=js&"
import style0 from "./UserNameDialog.vue?vue&type=style&index=0&id=b6a47328&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a47328",
  null
  
)

export default component.exports